import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import withMobileDialog from "material-ui/Dialog/withMobileDialog";
import {
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
    AppBar,
    Toolbar,
    Button
} from "material-ui";
import PostEditor from "../components/PostEditor";
import {
    closeFeedbackDialog,
    submitFeedback
} from "../actions/feedback.actions";
import FeedbackIcon from "material-ui-icons/Feedback";

const styleSheet = theme => ({
    textField: {
        width: 300,
        marginRight: theme.spacing.unit
    },
    appBar: {
        width: "100%",
        marginTop: theme.spacing.unit
    },
    feedbackIcon: {
        marginTop: 2,
        marginRight: 2 * theme.spacing.unit
    },
    flex: {
        flex: 1
    }
});

class FeedbackDialog extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        open: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        request: PropTypes.object.isRequired,
        fullScreen: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired
    };

    state = {
        body: ""
    };

    onChange = body => {
        this.setState({ body });
    };

    componentDidUpdate(prevProps) {
        if (this.editor && !prevProps.open && this.props.open) {
            if (this.editor) {
                this.editor.focus();
            }
        }
        if (!prevProps.success && this.props.success) {
            this.setState({ body: "" });
        }
    }

    renderDialogContent() {
        const { body } = this.state;
        const { success, t } = this.props;
        if (success) {
            return (
                <DialogContent>
                    <Typography type="body1">
                        {t(
                            "feedbackDialog.Message sent! Thank you for your feedback"
                        )}
                    </Typography>
                </DialogContent>
            );
        }
        return (
            <DialogContent>
                <PostEditor
                    innerRef={r => {
                        this.editor = r;
                    }}
                    onChange={this.onChange}
                    text={body}
                    placeholder={t("feedbackDialog.How can we help you?")}
                />
            </DialogContent>
        );
    }

    handleRequestClose = () => {
        this.props.dispatch(closeFeedbackDialog());
    };

    submitFeedback = () => {
        let body = this.getBody();

        this.props.dispatch(submitFeedback({ body }));
    };

    getBody = () => {
        let { body } = this.state;
        body = body || "";
        return body.trim();
    };

    renderDialogActions() {
        const { request: { requesting }, success, t } = this.props;
        let body = this.getBody();

        if (success) {
            return (
                <DialogActions>
                    <Button onClick={this.handleRequestClose}>
                        {t("feedbackDialog.Close")}
                    </Button>
                </DialogActions>
            );
        }
        return (
            <DialogActions>
                <Button onClick={this.handleRequestClose}>
                    {t("feedbackDialog.Close")}
                </Button>
                <Button
                    onClick={this.submitFeedback}
                    disabled={requesting || !body}>
                    {t("feedbackDialog.Send")}
                </Button>
            </DialogActions>
        );
    }

    render() {
        const { fullScreen, open, classes, t } = this.props;
        return (
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                open={open}
                onClose={this.handleRequestClose}>
                <AppBar
                    className={classes.appBar}
                    position="static"
                    style={{ backgroundColor: "white" }}
                    elevation={0}>
                    <Toolbar>
                        <FeedbackIcon className={classes.feedbackIcon} />
                        <Typography
                            className={classes.flex}
                            type="title"
                            color="inherit">
                            {t("feedbackDialog.Leave us a message")}
                        </Typography>
                    </Toolbar>
                </AppBar>
                {this.renderDialogContent()}
                {this.renderDialogActions()}
            </Dialog>
        );
    }
}

function mapStateToProps({ feedback: { open, success, request } }) {
    return {
        open,
        success,
        request
    };
}

export default withMobileDialog({ breakpoint: "xs" })(
    wrapComponent(FeedbackDialog, styleSheet, mapStateToProps)
);



// WEBPACK FOOTER //
// ./src/containers/FeedbackDialog.jsx